import React, { useEffect, useState } from "react";
import { getDatabase, ref, onValue, update , remove } from "firebase/database";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { FaTrash } from "react-icons/fa"; 
import "./AltAlarm.css";

const AltAlarm = () => {
  const [alarms, setAlarms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);
  const [hasNewAlarm, setHasNewAlarm] = useState(false);
  const [sessionExpired, setSessionExpired] = useState(false); // NEW

  useEffect(() => {
    const auth = getAuth();

    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserId(user.uid);
        setSessionExpired(false);
      } else {
        setUserId(null);
        setAlarms([]);
        setSessionExpired(true); // Mark session as expired
        setLoading(false); // Stop loading
      }
    });

    return () => unsubscribeAuth();
  }, []);

 useEffect(() => {
  const auth = getAuth();
  const db = getDatabase();
  const connectedRef = ref(db, ".info/connected");

  // Step 1: Check internet
  if (!navigator.onLine) {
    setError("You are offline. Please check your internet connection.");
    setLoading(false);
    return;
  }

  // Step 2: Auth check
  const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
    if (!user) {
      setSessionExpired(true); // Session expired
      setError(""); // clear other errors
      setLoading(false);
      return;
    }

    setSessionExpired(false);
    setUserId(user.uid);
    setError(""); // clear any previous error

    // Step 3: Firebase connection check
    onValue(connectedRef, (snap) => {
      if (!navigator.onLine) {
        setError("You are offline. Please check your internet connection.");
        setLoading(false);
        return;
      }

      if (snap.val() === false) {
        setError("Could not connect to Firebase. Please try again.");
        setLoading(false);
        return;
      }

      // Step 4: Fetch alarms only after auth + firebase connected
      const alarmsRef = ref(db, `alt_alarm/${user.uid}`);

      const unsubscribe = onValue(
        alarmsRef,
        (snapshot) => {
          if (snapshot.exists()) {
            const alarmsData = snapshot.val();
            const alarmList = Object.entries(alarmsData).map(
              ([alarmId, alarm]) => ({
                alarmId,
                ...alarm,
              })
            );
            setAlarms(alarmList);
            setHasNewAlarm(alarmList.some((alarm) => alarm.isNew));
          } else {
            setAlarms([]);
          }
          setError(""); // clear any load error
          setLoading(false);
        },
        (error) => {
          setError("Failed to load alarms: " + error.message);
          setLoading(false);
        }
      );

      // Cleanup alarms listener
      return () => unsubscribe();
    });
  });

  // Cleanup auth listener
  return () => unsubscribeAuth();
}, []);

// delete alarms
  const deleteAlarm = async (alarmId) => {
    try {
      const db = getDatabase();
      const alarmRef = ref(db, `alt_alarm/${userId}/${alarmId}`);
      await remove(alarmRef);
      setAlarms((prev) => prev.filter((alarm) => alarm.alarmId !== alarmId)); // ⬅ update state instantly
    } catch (err) {
      setError("Failed to delete alarm: " + err.message);
    }
  };


  const clearNewAlarms = async () => {
    const db = getDatabase();
    if (userId) {
      const alarmsRef = ref(db, `alt_alarm/${userId}`);
      const updates = {};
      alarms.forEach((alarm) => {
        updates[`${alarm.alarmId}/isNew`] = false;
      });
      await update(alarmsRef, updates);
      setHasNewAlarm(false);
    }
  };

  // 🔴 Show session expired error
  if (sessionExpired) {
    return (
      <p className="text-center mt-5 text-danger fw-bold">
        Session expired. Please login again.
      </p>
    );
  }

  if (loading) return <p>Loading alarms...</p>;

  if (error)
    return <p className="error-message text-danger fw-bold">{error}</p>;

  if (alarms.length === 0) {
    return (
      <p className="text-center mt-5 text-danger" style={{ fontWeight: "600" }}>
        No alarms available for your account.
      </p>
    );
  }

  return (
    <div className="container-fluid Alarm-cont">
      <div className="alarm-dashboard">
        <h2 className="alarm-Text">Your Alerts</h2>

        {hasNewAlarm && (
          <button onClick={clearNewAlarms} className="btn btn-warning mb-3">
            Clear New Alarms
          </button>
        )}

        {alarms.map((alarm) => (
  <div
    key={alarm.alarmId}
    className="alarm-card d-flex justify-content-between align-items-start"
    style={{
      borderLeftColor: alarm.isNew ? "#dc3545" : "#ffc107",
      backgroundColor: alarm.isNew ? "#ffe2e2" : "#fff3cd",
    }}
  >
    <div>
      <p>
        <strong>Issue:</strong> {alarm.type || "N/A"}
      </p>
      <p>
        <strong>Reason:</strong> {alarm.reason || "N/A"}
      </p>
      <p>
        <strong>Message:</strong>{" "}
        {alarm.message || "No message provided."}
      </p>
      <p>
       <strong>Last Updated:</strong>{" "}
{alarm.lastUpdated
  ? new Date(alarm.lastUpdated).toLocaleString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
      timeZone: "Asia/Kolkata",
    })
  : "N/A"}

      </p>
      {alarm.isNew && <p className="new-alert">🆕 This is a new alert</p>}
    </div>

    {/* Delete button */}
    <button
      className="btn btn-sm btn-danger ms-3"
      onClick={() => deleteAlarm(alarm.alarmId)}
      title="Delete Alarm"
    >
      <FaTrash />
    </button>
  </div>
))}

      </div>
      
    </div>
  );
};

export default AltAlarm;
